import React from 'react';
import PropTypes from 'prop-types';

import { mixins } from '../../../styles';

import Button from '../../ui/Button';
import CheckboxButton from '../../ui/CheckboxButton';
import Popover from '../../ui/Popover';
import Spinner from '../../ui/Spinner';
import TaraHeader from './TaraHeader';
import TaraPopoverFooter from './TaraPopoverFooter';
import TaraQuestion from './TaraQuestion';
import TaraText from './TaraText';

const noop = () => {};

const DefaultTaraMessage = () => (
  <div>
    <div>Hi there!</div>
    <div>
      <span>To get started, can I ask you a few questions to get to know <em>you</em> better?</span>
    </div>
  </div>
);

const IntroductionTaraMessage = () => (
  <div>
    <div>
    Hi there, I&apos;m <strong>TARA</strong>, and I'll be assisting you with your ticket purchase.
    </div>
    <div>
      <span>To get started, can I ask you a few questions to get to know <em>you</em> better?</span>
    </div>
  </div>
);

const styleButton = {
  height: 48,
  width: '100%',
};

const styleTaraHeader = {
  marginBottom: 32,
};

const styleSpaced = {
  marginBottom: 16,
};

const HEADER_HEIGHT = 56;
const SPACING = 32;
const QUESTION_SCROLL_OFFSET = HEADER_HEIGHT + SPACING;

class TaraSurvey extends React.PureComponent {
  static propTypes = {
    onCancel: PropTypes.func,
    onSubmit: PropTypes.func,
    taraSetHasMadeIntroduction: PropTypes.func,

    survey: PropTypes.shape({
      surveyId: PropTypes.number,
      siteId: PropTypes.number,
      questionList: PropTypes.arrayOf(PropTypes.shape({
        questionText: PropTypes.string,
        questionId: PropTypes.number,
        sortOrder: PropTypes.number,
        answerList: PropTypes.arrayOf(PropTypes.shape({
          answerText: PropTypes.string,
          answerId: PropTypes.number,
          sortOrder: PropTypes.number,
        })),
      })),
    }),

    hasButton: PropTypes.bool,
    hasMadeIntroduction: PropTypes.bool,
    isAnimated: PropTypes.bool,
    isOpen: PropTypes.bool,
  };

  static defaultProps = {
    taraSetHasMadeIntroduction: noop,
    onCancel: noop,
    onSubmit: noop,

    hasButton: false,
    hasMadeIntroduction: false,
    isAnimated: false,
    isOpen: undefined,
  };

  state = {
    answersByQuestionId: {},
    currentQuestionIndex: 0,
    hasFinishedSurvey: false,
    isQualified: false,
    isReady: false,
  };

  popoverScrollRef = null;
  questionRefs = [];

  componentDidMount() {
    this.hasMounted = true;

    setTimeout(() => {
      this.setIsReady(true);
    }, 1600);
  }

  componentWillReceiveProps(nextProps) {
    const {
      hasMadeIntroduction,
    } = nextProps;

    const isChangingHasMadeIntroduction = hasMadeIntroduction !== this.props.hasMadeIntroduction;

    if (isChangingHasMadeIntroduction) {
      this.taraMessage = this.getTaraMessage(nextProps);
    }
  }

  componentWillUnmount() {
    this.hasMounted = false;
  }

  taraMessage = this.getTaraMessage(this.props);

  getTaraMessage(props) {
    const {
      hasMadeIntroduction,
    } = props;

    if(!hasMadeIntroduction)
      this.props.analyticsRecordActionRequest('tara','introduction', '');

    return hasMadeIntroduction ?
      (<DefaultTaraMessage />)
      :
      (<IntroductionTaraMessage />);
  }

  setAnswer = (questionId, answerId) => {
    const {
      answersByQuestionId,
      currentQuestionIndex,
      hasFinishedSurvey,
    } = this.state;

    const existingAnswer = answersByQuestionId[questionId];
    const { length } = this.props.survey.questionList;

    const nextQuestionIndex = !existingAnswer ? (currentQuestionIndex + 1) : currentQuestionIndex;

    this.setState({
      currentQuestionIndex: nextQuestionIndex,
      answersByQuestionId: {
        ...this.state.answersByQuestionId,
        [questionId]: !existingAnswer ? answerId : null,
      },

      hasFinishedSurvey: hasFinishedSurvey ? true : (currentQuestionIndex === length - 1),
    });

    setTimeout(() => this.scrollToQuestion(nextQuestionIndex), 300);
  };

  setIsReady = (isReady) => {
    if (this.hasMounted) {
      this.setState({ isReady });
    }
  };

  setPopoverScrollRef = ref => this.popoverScrollRef = ref;
  setQuestionRef = index => ref => this.questionRefs[index] = ref;

  scrollToQuestion = (index) => {
    if (this.questionRefs[index] && this.questionRefs[index].offsetTop) {
      const top = this.questionRefs[index].offsetTop - QUESTION_SCROLL_OFFSET;
      this.popoverScrollRef.scrollTo({ top, behaviour: 'smooth' });
    }
  };

  createHandleClick = (question, answer) => () => {
    this.setAnswer(question.questionId, answer.answerId);
    this.props.analyticsRecordActionRequest('survey','answer', this.state.currentQuestionIndex); 
  };

  handleClickYes = () => {
    
    this.setState({ isQualified: true })
    this.props.analyticsRecordActionRequest('survey','start', ''); 
  };

  handleCancel = (e) => {
    const form = {
      survey: this.props.survey,
      answers: this.state.answersByQuestionId,
    };

    this.props.analyticsRecordActionRequest('survey','cancel', ''); 
    this.props.onCancel(e, form);
  };

  handleSubmit = (e) => {
    const form = {
      survey: this.props.survey,
      answers: this.state.answersByQuestionId,
    };

    this.props.onSubmit(e, form);
  };

  renderFooter() {
    if (!this.state.hasFinishedSurvey) {
      return null;
    }

    return (
      <TaraPopoverFooter>
        <Button
          color="accent"
          label="Submit"
          isRaised
          onClick={this.handleSubmit}
          style={styleButton}
        />
      </TaraPopoverFooter>
    );
  }

  renderPopoverOpen = (this.props.hasButton ? handleOpen => (
    <Button onClick={handleOpen}>
      Tara Survey
    </Button>
  ) : null);

  renderQualifier() {
    return (
      <TaraPopoverFooter>
        <Button
          color="accent"
          label="Yes"
          isRaised
          onClick={this.handleClickYes}
          style={styleButton}
        />
        <Button
          className="LeftButton"
          color="primary"
          label="No Thanks"
          onClick={this.handleCancel}
          style={styleButton}
        />
      </TaraPopoverFooter>
    )
  }

  renderQualifiedText() {
    return (
      <TaraText
        hasNoDelay
        isQuestion
        isAnimated
      >
        Great! It&apos;s only a few questions, so let&apos;s jump right in!
      </TaraText>
    );
  }

  renderQuestion = (question, index) => {
    const {
      answersByQuestionId,
      currentQuestionIndex,
    } = this.state;

    if (currentQuestionIndex < index) {
      return null;
    }

    const {
      questionId,
      questionText,
    } = question;

    const existingAnswer = answersByQuestionId[questionId];

    const renderAnswer = (answer, index) => (!existingAnswer || existingAnswer === answer.answerId) ? (
      <CheckboxButton
        key={answer.answerText}
        color={existingAnswer === answer.answerId ? 'primary' : undefined}
        label={answer.answerText}
        isChecked={existingAnswer === answer.answerId}
        onClick={this.createHandleClick(question, answer)}
        style={(index !== question.answerList.length - 1) && styleSpaced}
      />
    ) : null;

    return (
      <TaraQuestion
        key={questionId}
        id={questionId}
        text={questionText}
        isAnimated={this.props.isAnimated}
        isCollapsed={!!answersByQuestionId[questionId]}
        questionRef={this.setQuestionRef(index)}
      >
        {question.answerList.map(renderAnswer)}
      </TaraQuestion>
    );
  };

  renderQuestions() {
    return this.props.survey.questionList.map(this.renderQuestion);
  }

  renderScreen() {
    return (
      <div style={{ position: 'absolute', ...mixins.fillToParent, background: 'rgba(255,255,255,0.87)'}}>
        <Spinner isReady={!this.props.isFetching} />
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <TaraText
          hasNoDelay
          isQuestion
          isAnimated
        >
          Thanks for that, I&apos;ll find tickets with you&apos;re preferences in mind!
        </TaraText>
        <TaraPopoverFooter>
          <Button
            color="primary"
            label="Okay"
            onClick={this.handleCancel}
            style={styleButton}
          />
        </TaraPopoverFooter>
      </div>
    );
  }

  renderSurvey() {
    const {
      isQualified,
      isReady,
    } = this.state;

    return (
      <div>
        {!isQualified && this.renderQualifier()}
        {isQualified && this.renderQualifiedText()}
        {isReady && isQualified && this.renderQuestions()}

        {this.renderFooter()}
      </div>
    );
  }

  render() {
    return (
      <Popover
        onCancel={this.handleCancel}
        renderOpen={this.renderPopoverOpen}
        isOpen={this.props.isOpen}
        hasOk={false}
        popoverScrollRef={this.setPopoverScrollRef}
        popoverWidth={480}
        closeOnClickBackdrop={this.props.canDismiss}
      >
        <TaraHeader
          message={this.taraMessage}
          style={styleTaraHeader}
        />

        {this.props.status === 'SUCCESS' ? this.renderSuccess() : this.renderSurvey()}
        {this.props.isFetching && this.renderScreen()}
      </Popover>
    );
  }
}

export default TaraSurvey;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraSurvey.js